import { render } from "./AdvAltHome.vue?vue&type=template&id=c2c04290&scoped=true&ts=true&lang=pug"
import script from "./AdvAltHome.vue?vue&type=script&lang=ts"
export * from "./AdvAltHome.vue?vue&type=script&lang=ts"

import "./AdvAltHome.vue?vue&type=style&index=0&id=c2c04290&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c04290"]])

export default __exports__